import { render } from "./ButtonsExample.vue?vue&type=template&id=3ae0de55&scoped=true"
import script from "./ButtonsExample.vue?vue&type=script&lang=js"
export * from "./ButtonsExample.vue?vue&type=script&lang=js"

import "./ButtonsExample.vue?vue&type=style&index=0&id=3ae0de55&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae0de55"]])

export default __exports__